export default {
  events: {
    fetching: false,
    fetched: false,
    submitting: false,
    submitted: false,
    data: null
  }
}
